import { QUERY_REMORTGAGE, QUERY_FIRST_TIME_BUYER, QUERY_HOME_MOVER}  from "@/utils/Constants";

export class ProductSearchQuery {
    static newRemortgage(propertyValue, remainingBalance, term) {
        return new ProductSearchQuery({
            type: QUERY_REMORTGAGE,
            propertyValue: propertyValue,
            remainingBalance: remainingBalance,
            term: term 
        });
    }
    
    type = "";
    propertyValue = 0;
    remainingBalance = 0;
    deposit = 0
    term = 0;
    currentLender = null;
    currentMonthly = null;
    
    constructor(obj) {
        this.populate(obj);
    }
    
    populate(obj) {
        if (obj != null) {
            Object.assign(this, obj);
        }
    }
    
    isRemortgage() {
        return this.type === QUERY_REMORTGAGE;
    }
    
    isFirstTimeBuyer() {
        return this.type === QUERY_FIRST_TIME_BUYER;
    }
    
    isMovingHouse() {
        return this.type === QUERY_HOME_MOVER;
    }
    
    borrowingAmount() {
        return this.type === QUERY_FIRST_TIME_BUYER ? this.propertyValue - this.deposit : this.remainingBalance
    }
    
    ltv() {
        return (this.borrowingAmount() / this.propertyValue);
    }
}